<div class="modal-content">
  <ng-container *ngIf="chatEmailData; else emailChamado">
    <div class="modal-header">
      <ng-container *ngIf="chatEmailData.is_iniciar_conversa; else titleResposta">
        <h6 class="modal-title" id="modal-title-default">
          {{'INICIAR_CONVERSA' | translate}} Email {{chatEmailData.destinatario}}
        </h6>
      </ng-container>
      <ng-template #titleResposta>
        <h6 class="modal-title" id="modal-title-default">
          Email
        </h6>
      </ng-template>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
    <div class="modal-body pb-0 mb-0">
      <div *ngIf="chatEmailData.is_iniciar_conversa" class="row">
        <div class="col-12 mb-4">
          <span style="font-weight: bold;">{{ 'INICIO_CHAT_EMAIL_CAIXA_FILA' |
            translate:{email:chatEmailData.caixa.email,fila:chatEmailData.caixa.fila_atendimento_descricao} }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-11">
          <div class="form-group">
            <label [translate]="'DESTINATARIO_EMAIL'"></label>
            <input-tags-padrao [sendAsArray]="true" [required]="true" (selectChange)="adicionaDestinatario($event)"
              (showError)="showInvalidEmail()" [model]="emailContato"></input-tags-padrao>
          </div>
        </div>
        <div class="col-1">
          <div>
            <i class="far fa-address-book" [title]="'ABRIR_CONTATOS_CLIENTE' | translate" (click)="abrirModalContatos()"
              style="
                        font-size: 30px;
                        margin-top: 40px;
                        margin-left: 9px;
                        cursor: pointer;
                      "></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label [translate]="'ASSUNTO_EMAIL'"></label>
            <input type="text" maxlength="255" class="form-control" [ngClass]="{ required: !envioEmail.assunto }"
              [(ngModel)]="envioEmail.assunto" [disabled]="chatEmailProps?.assunto_bloqueado" />
          </div>
        </div>
      </div>
      <div *ngIf="chatEmailProps && chatEmailProps.ia_habilitada_email" [formGroup]="sendEmailFromTicketForm"
        class="d-flex mt-4 mb-4">
        <app-chat-gpt class="flex-grow-1" [chatGPTFormGroup]="sendEmailFromTicketForm" [aiChat]="true"
          chatGPTFormControlName="chatGPT" formControlName="chatGPT" name="chatGPT"
          (chatGPTButtonClicked)="generateChatGPT()"></app-chat-gpt>
        <button (click)="cleanChatGPTSuggestion()" class="btn btn-light btn-md badge-pill"
          style="font-family: PoppinsRegular">
          {{ "LIMPAR_SUGESTAO" | translate }}
        </button>
      </div>
      <div class="row">
        <form [formGroup]="sendEmailFromTicketForm" class="col-12">
          <div class="form-group">
            <label [translate]="'CORPO_EMAIL'"></label>
            <ckeditor [editor]="Editor" class="expanded" [ngClass]="{'required': checkFields('description')}"
              [(ngModel)]="editorModel.editorData" [ngModelOptions]="{standalone: true}"
              (ready)="onEditorReady($event)">
            </ckeditor>
            <button type="button" class="btn-template-novo-editor" (click)="openTemplateModal()">TEMPLATES</button>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label [translate]="'ANEXOS'"></label>
          </div>
        </div>
      </div>
      <div class="row" appDnd (fileDropped)="onFileDropped($event)">
        <div class="col-3 mb-4" *ngFor="let file of anexos; let i = index">
          <button type="button" class="btn btn-sm-rounded-milvus bg-danger"
            style="position: absolute; right: 13px; top: -13px; color: white" data-dismiss="modal" aria-label="Close"
            (click)="excluirAnexo(i)">
            <i class="fas fa-times"></i>
          </button>
          <div class="preview-upload-file">
            <div class="div-img-anexo" *ngIf="
                      file.type === 'image/jpeg' ||
                      file.type === 'image/png' ||
                      file.type === 'image/svg+xml'
                    ">
              <img class="mt-4" [src]="file.url" style="width: 100px" />
            </div>
            <audio controls class="mt-4" *ngIf="file.type === 'audio/mp3'" style="width: 240px">
              <source [src]="file.url" type="audio/mpeg" />
            </audio>
            <video controls class="mt-3" style="justify-self: center" *ngIf="file.type === 'video/mp4'" width="166"
              height="102">
              <source [src]="file.url" type="video/mp4" />
            </video>
            <i *ngIf="file.type === 'application/pdf'" class="far fa-file-pdf icon-anexo mt-4"></i>
            <i *ngIf="file.type === 'application/zip'" class="far fa-file-archive icon-anexo mt-4"></i>
            <i *ngIf="file.type === 'application/vnd.ms-excel'" class="far fa-file-excel icon-anexo mt-4"></i>
            <i *ngIf="
                      file.type !== 'image/jpeg' &&
                      file.type !== 'image/png' &&
                      file.type !== 'image/svg+xml' &&
                      file.type !== 'application/pdf' &&
                      file.type !== 'application/zip' &&
                      file.type !== 'application/vnd.ms-excel' &&
                      file.type !== 'audio/mp3' &&
                      file.type !== 'video/mp4'
                    " class="far fa-file icon-anexo mt-4"></i>
            <span style="margin-top: 0 !important; font-size: 13px; margin-left: 15px;" [title]="file.name">{{ file.name
              | ellipsis: 50 }}</span>
          </div>
          <button type="button" class="btn btn-sm-rounded-milvus btn-light"
            style="position: absolute; left: 20px; top: 135px; color: black" data-dismiss="modal" aria-label="Close"
            (click)="downloadAnexo(file)" *ngIf="
                    file &&
                    file.url
                  ">
            <i class="fa fa-download"></i>
          </button>
        </div>
        <div class="col-5">
          <div class="inputFileArea" (click)="triggerFileInput()" container=".modal" [ngbTooltip]="tooltipAttachment"
            tooltipClass="tooltip_attachment">
            <div class="anexo-label">
              <i _ngcontent-yvq-c100="" class="fas fa-paperclip fa-3x icon-chat-opt ng-star-inserted"
                style="margin-bottom: 20px;"></i>
              <span [translate]="'CLIQUE_ARRASTE_ARQUIVO'"></span>
            </div>
          </div>
          <input id="fileInputEmail" type="file" accept="{{ uploadFileType }}"
            (change)="changeFile($event.target.files)" multiple />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button *ngIf="!chatEmailData.is_iniciar_conversa" type="button" class="btn btn-success badge-pill"
        (click)="enviarEmailChat()" [disabled]="verificaSeDesativa() || salvando">
        <i class="fas fa-paper-plane"></i>
        <span [translate]="'ENVIAR'"></span>
      </button>
      <button *ngIf="chatEmailData.is_iniciar_conversa" type="button" class="btn btn-success badge-pill"
        (click)="iniciarEmailChat()"
        [disabled]="(!envioEmail.assunto.length || checkFields('description')) || salvando">
        <i class="fas fa-paper-plane"></i>
        <span [translate]="'INICIAR_CONVERSA'"></span>
      </button>
    </div>
  </ng-container>
  <ng-template #emailChamado>
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-default">
        Email <span class="text-danger">#{{ emailData.chamado.codigo }}</span>
      </h6>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
    <div class="modal-body pb-0 mb-0">
      <div class="row">
        <div class="col-11">
          <div class="form-group">
            <label [translate]="'DESTINATARIO_EMAIL'"></label>
            <input-tags-padrao [sendAsArray]="true" [required]="true" (selectChange)="adicionaDestinatario($event)"
              (showError)="showInvalidEmail()" [model]="emailContato"></input-tags-padrao>
          </div>
        </div>
        <div *ngIf="emailData.chamado && !emailData.chamado.is_global_incident" class="col-1">
          <div>
            <i class="far fa-address-book" [title]="'ABRIR_CONTATOS_CLIENTE' | translate" (click)="abrirModalContatos()"
              style="
                font-size: 30px;
                margin-top: 40px;
                margin-left: 9px;
                cursor: pointer;
              "></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label [translate]="'ASSUNTO_EMAIL'"></label>
            <input type="text" maxlength="255" class="form-control" [ngClass]="{ required: !envioEmail.assunto }"
              [(ngModel)]="envioEmail.assunto" />
          </div>
        </div>
        <!-- <div class="col-4">
          <div class="form-group">
            <label [translate]="'ANEXOS_DO_CHAMADO'"></label>
            <select-padrao
              [entidade]="'selectAnexosChamado'"
              [params]="emailData.chamado.id"
              [returnObj]="true"
              (selectChange)="adicionaAnexo($event)"
            ></select-padrao>
          </div>
        </div> -->
      </div>
      <div *ngIf="emailData?.chatGPTIntegrationStatus && emailData?.chatGPTEmail" [formGroup]="sendEmailFromTicketForm"
        class="d-flex mt-4 mb-4">
        <app-chat-gpt class="flex-grow-1" [chatGPTFormGroup]="sendEmailFromTicketForm" [aiChat]="true"
          chatGPTFormControlName="chatGPT" formControlName="chatGPT" name="chatGPT"
          (chatGPTButtonClicked)="generateChatGPT()"></app-chat-gpt>
        <button (click)="cleanChatGPTSuggestion()" class="btn btn-light btn-md badge-pill"
          style="font-family: PoppinsRegular">
          {{ "LIMPAR_SUGESTAO" | translate }}
        </button>
      </div>
      <div class="row">
        <form [formGroup]="sendEmailFromTicketForm" class="col-12">
          <div class="form-group">
            <label [translate]="'CORPO_EMAIL'"></label>
            <ckeditor [editor]="Editor" class="expanded" [ngClass]="{'required': checkFields('description')}"
              [(ngModel)]="editorModel.editorData" [ngModelOptions]="{standalone: true}"
              (ready)="onEditorReady($event)">
            </ckeditor>
            <button type="button" class="btn-template-novo-editor" (click)="openTemplateModal()">TEMPLATES</button>
          </div>
        </form>
      </div>
      <!-- <ng-template *ngIf="anexos.length > 0" class="row">
        <div class="col-12 d-flex align-items-center">
          <i class="fas fa-paperclip mr-4"></i>
          <div *ngFor="let anexo of anexos">
            <span class="text-success mr-3">{{ anexo.text }}</span>
          </div>
        </div>
      </ng-template> -->
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label [translate]="'ANEXOS'"></label>
          </div>
        </div>
      </div>
      <div class="row" appDnd (fileDropped)="onFileDropped($event)">
        <div class="col-3 mb-4" *ngFor="let file of anexos; let i = index">
          <button type="button" class="btn btn-sm-rounded-milvus bg-danger"
            style="position: absolute; right: 13px; top: -13px; color: white" data-dismiss="modal" aria-label="Close"
            (click)="excluirAnexo(i)">
            <i class="fas fa-times"></i>
          </button>
          <div class="preview-upload-file">
            <div class="div-img-anexo" *ngIf="
                file.type === 'image/jpeg' ||
                file.type === 'image/png' ||
                file.type === 'image/svg+xml'
              ">
              <img class="mt-4" [src]="file.url" style="width: 100px" />
            </div>
            <audio controls class="mt-4" *ngIf="file.type === 'audio/mp3'" style="width: 240px">
              <source [src]="file.url" type="audio/mpeg" />
            </audio>
            <video controls class="mt-3" style="justify-self: center" *ngIf="file.type === 'video/mp4'" width="166"
              height="102">
              <source [src]="file.url" type="video/mp4" />
            </video>
            <i *ngIf="file.type === 'application/pdf'" class="far fa-file-pdf icon-anexo mt-4"></i>
            <i *ngIf="file.type === 'application/zip'" class="far fa-file-archive icon-anexo mt-4"></i>
            <i *ngIf="file.type === 'application/vnd.ms-excel'" class="far fa-file-excel icon-anexo mt-4"></i>
            <i *ngIf="
                file.type !== 'image/jpeg' &&
                file.type !== 'image/png' &&
                file.type !== 'image/svg+xml' &&
                file.type !== 'application/pdf' &&
                file.type !== 'application/zip' &&
                file.type !== 'application/vnd.ms-excel' &&
                file.type !== 'audio/mp3' &&
                file.type !== 'video/mp4'
              " class="far fa-file icon-anexo mt-4"></i>
            <span style="margin-top: 0 !important; font-size: 13px; margin-left: 15px;" [title]="file.name">{{ file.name
              | ellipsis: 50 }}</span>
          </div>
          <button type="button" class="btn btn-sm-rounded-milvus btn-light"
            style="position: absolute; left: 20px; top: 135px; color: black" data-dismiss="modal" aria-label="Close"
            (click)="downloadAnexo(file)" *ngIf="
              file &&
              file.url
            ">
            <i class="fa fa-download"></i>
          </button>
        </div>
        <div class="col-5">
          <div class="inputFileArea" (click)="triggerFileInput()" container=".modal" [ngbTooltip]="tooltipAttachment"
            tooltipClass="tooltip_attachment">
            <div class="anexo-label">
              <i _ngcontent-yvq-c100="" class="fas fa-paperclip fa-3x icon-chat-opt ng-star-inserted"
                style="margin-bottom: 20px;"></i>
              <span [translate]="'CLIQUE_ARRASTE_ARQUIVO'"></span>
            </div>
          </div>
          <input id="fileInputEmail" type="file" accept="{{ uploadFileType }}"
            (change)="changeFile($event.target.files)" multiple />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success badge-pill" (click)="enviarEmail()"
        [disabled]="verificaSeDesativa() || salvando">
        <i class="fas fa-paper-plane"></i>
        <span [translate]="'ENVIAR'"></span>
      </button>
    </div>
  </ng-template>
</div>

<ng-template #tooltipAttachment>
  <div class="d-grid">
    <span [translate]="'ANEXO_MAXIMO_ARQUIVOS'"></span>
    <span [translate]="'ANEXO_TAMANHO_ARQUIVO_EMAIL'"></span>
    <span [translate]="'ANEXO_ARQUIVOS_SUPORTADOS'"></span>
  </div>
</ng-template>